export default {
  STATUS: [
    { LABEL: '5 DIAS', NUM_DAYS: 5 },
    { LABEL: '10 DIAS', NUM_DAYS: 10 },
    { LABEL: '15 DIAS', NUM_DAYS: 15 },
    { LABEL: '30 DIAS', NUM_DAYS: 30 },
  ],
};
